module.exports = __webpack_public_path__ + "static/media/icon_error-data.ff02ebc1.svg";